window.newsLetterModal = new Modal(document.getElementById('newsLetterModal'), {
    keyboard: false
});
